import { Box, TextField } from "@mui/material";
import React, { useState } from "react";
import SectionLabel from "../../../widgets/SectionLabel";
import WabaTextMsg from "../../../widgets/WabaTextMsg";
import { LoadingButton } from "@mui/lab";
import SaveIcon from "@mui/icons-material/Save";
import PageTitle from "../../../widgets/PageTitle";
import BackBtn from "../../../widgets/BackBtn";
import MultiCreateAutocomplete from "../../../widgets/MultiCreateAutocomplete";
import { API_ENDPOINT } from "../../../utils/constants";
import MultiSelectStringsApi from "../../../widgets/MultiSelectStringsApi";
import { getHeader, toastError } from "../../../utils/util";
import axios from "axios";
import { toast } from "react-toastify";
import SaveButton from "./SaveButton";

const TextMessage = ({
  value = { text: "" },
  isEdit = false,
  editId,
  preview = false,
  onUpdate,
}) => {
  const [body, setBody] = useState(value?.text ?? "");
  const [reply, setReply] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const handleSubmit = async () => {
    if (!body) {
      toast.error(`Body text is required`);
      return;
    }
    if (!reply && !isEdit && !preview) {
      toast.error(`Reply text is required!`);
      return;
    }

    const payloadObject = { type: "text", text: body };
    if (isEdit) {
      payloadObject.id = editId;
      payloadObject.isEdit = true;
    } else {
      payloadObject.triggerText = reply;
    }

    if (preview) {
      onUpdate?.({ type: "text", text: body });
      return;
    }

    try {
      setSubmitting(true);
      const response = await axios.post(
        `${API_ENDPOINT}/message/save-message`,
        payloadObject,
        getHeader()
      );
      toast.success(response.data.message);
      resetFields();
    } catch (error) {
      toastError(error);
    } finally {
      setSubmitting(false);
    }
  };
  function resetFields() {
    setBody("");
    setReply("");
  }
  return (
    <Box px={3}>
      {preview ? (
        <SectionLabel>Text Message</SectionLabel>
      ) : (
        <PageTitle>Text Message</PageTitle>
      )}
      <Box my={2}>
        <WabaTextMsg
          value={body}
          onChange={(newV) => {
            setBody(newV);
          }}
        />
        {!preview ? (
          <TextField
            fullWidth
            sx={{ my: 2 }}
            label="Reply text"
            disabled={isEdit}
            value={reply}
            onChange={(e) => setReply(e.target.value)}
            variant="outlined"
            size="small"
          />
        ) : (
          <></>
        )}
        <SaveButton loading={submitting} onClick={handleSubmit} />
      </Box>
    </Box>
  );
};

export default TextMessage;
